(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["distillery-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DEG = Math.PI / 180;
    const editorStates = new Map();
    const vertexSource = `attribute vec2 p; varying vec2 uv; void main(){uv=p*.5+.5;gl_Position=vec4(p,0.,1.);}`;
    const fragmentSource = `precision highp float; varying vec2 uv; uniform sampler2D pano; uniform float yaw; uniform float pitch; uniform float fov; uniform float aspect; const float PI=3.14159265359; vec3 rx(vec3 v,float a){float c=cos(a),s=sin(a);return vec3(v.x,c*v.y-s*v.z,s*v.y+c*v.z);} vec3 ry(vec3 v,float a){float c=cos(a),s=sin(a);return vec3(c*v.x+s*v.z,v.y,-s*v.x+c*v.z);} void main(){vec2 n=uv*2.-1.;float t=tan(fov*.5);vec3 r=normalize(vec3(n.x*t*aspect,n.y*t,-1.));r=rx(r,pitch);r=ry(r,yaw);float lon=atan(r.x,-r.z);float lat=asin(clamp(r.y,-1.,1.));vec2 e=vec2(fract(.5+lon/(2.*PI)),.5-lat/PI);gl_FragColor=texture2D(pano,e);}`;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const rotateX = (v, a) => ({ x: v.x, y: Math.cos(a) * v.y - Math.sin(a) * v.z, z: Math.sin(a) * v.y + Math.cos(a) * v.z });
    const rotateY = (v, a) => ({ x: Math.cos(a) * v.x + Math.sin(a) * v.z, y: v.y, z: -Math.sin(a) * v.x + Math.cos(a) * v.z });

    class PanoramaRenderer {
      constructor(canvas, onViewChange) {
        this.canvas = canvas;
        this.onViewChange = onViewChange;
        this.gl = canvas.getContext('webgl', { antialias: true, alpha: false });
        if (!this.gl) throw new Error('WebGL unavailable');
        this.yaw = 0;
        this.pitch = 0;
        this.fov = 78 * DEG;
        this.pointers = new Map();
        this.lastPinch = 0;
        this.program = this.createProgram(vertexSource, fragmentSource);
        this.locations = {
          p: this.gl.getAttribLocation(this.program, 'p'),
          pano: this.gl.getUniformLocation(this.program, 'pano'),
          yaw: this.gl.getUniformLocation(this.program, 'yaw'),
          pitch: this.gl.getUniformLocation(this.program, 'pitch'),
          fov: this.gl.getUniformLocation(this.program, 'fov'),
          aspect: this.gl.getUniformLocation(this.program, 'aspect')
        };
        const buffer = this.gl.createBuffer();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, buffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]), this.gl.STATIC_DRAW);
        this.gl.useProgram(this.program);
        this.gl.enableVertexAttribArray(this.locations.p);
        this.gl.vertexAttribPointer(this.locations.p, 2, this.gl.FLOAT, false, 0, 0);
        this.texture = this.gl.createTexture();
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
        this.bindEvents();
        this.resizeObserver = new ResizeObserver(() => this.render());
        this.resizeObserver.observe(canvas);
      }
      shader(type, source) {
        const shader = this.gl.createShader(type);
        this.gl.shaderSource(shader, source);
        this.gl.compileShader(shader);
        if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) throw new Error(this.gl.getShaderInfoLog(shader));
        return shader;
      }
      createProgram(vertex, fragment) {
        const program = this.gl.createProgram();
        this.gl.attachShader(program, this.shader(this.gl.VERTEX_SHADER, vertex));
        this.gl.attachShader(program, this.shader(this.gl.FRAGMENT_SHADER, fragment));
        this.gl.linkProgram(program);
        if (!this.gl.getProgramParameter(program, this.gl.LINK_STATUS)) throw new Error(this.gl.getProgramInfoLog(program));
        return program;
      }
      bindEvents() {
        this.canvas.addEventListener('pointerdown', event => {
          this.canvas.setPointerCapture(event.pointerId);
          this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        });
        this.canvas.addEventListener('pointermove', event => {
          const previous = this.pointers.get(event.pointerId);
          if (!previous) return;
          const current = { x: event.clientX, y: event.clientY };
          this.pointers.set(event.pointerId, current);
          if (this.pointers.size === 1) {
            this.yaw -= (current.x - previous.x) * .0035;
            this.pitch = clamp(this.pitch + (current.y - previous.y) * .0035, -1.35, 1.35);
          } else if (this.pointers.size === 2) {
            const points = [...this.pointers.values()];
            const distance = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
            if (this.lastPinch) this.fov = clamp(this.fov - (distance - this.lastPinch) * .003, 35 * DEG, 100 * DEG);
            this.lastPinch = distance;
          }
          this.render();
        });
        const release = event => {
          this.pointers.delete(event.pointerId);
          if (this.pointers.size < 2) this.lastPinch = 0;
        };
        this.canvas.addEventListener('pointerup', release);
        this.canvas.addEventListener('pointercancel', release);
        this.canvas.addEventListener('wheel', event => {
          event.preventDefault();
          this.fov = clamp(this.fov + event.deltaY * .0015, 35 * DEG, 100 * DEG);
          this.render();
        }, { passive: false });
        this.canvas.addEventListener('keydown', event => {
          const keys = ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','=','-'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft') this.yaw -= .08;
          if (event.key === 'ArrowRight') this.yaw += .08;
          if (event.key === 'ArrowUp') this.pitch = clamp(this.pitch + .06, -1.35, 1.35);
          if (event.key === 'ArrowDown') this.pitch = clamp(this.pitch - .06, -1.35, 1.35);
          if (event.key === '+' || event.key === '=') this.fov = clamp(this.fov - .08, 35 * DEG, 100 * DEG);
          if (event.key === '-') this.fov = clamp(this.fov + .08, 35 * DEG, 100 * DEG);
          this.render();
        });
      }
      load(source, yaw, pitch) {
        const request = this.loadRequest = (this.loadRequest || 0) + 1;
        this.yaw = Number(yaw || 0) * DEG;
        this.pitch = Number(pitch || 0) * DEG;
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => {
            if (request !== this.loadRequest) return resolve();
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, image);
            this.render();
            resolve();
          };
          image.onerror = reject;
          image.src = source;
        });
      }
      render() {
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        const width = Math.max(1, Math.round(this.canvas.clientWidth * ratio));
        const height = Math.max(1, Math.round(this.canvas.clientHeight * ratio));
        if (this.canvas.width !== width || this.canvas.height !== height) {
          this.canvas.width = width;
          this.canvas.height = height;
        }
        this.gl.viewport(0, 0, width, height);
        this.gl.useProgram(this.program);
        this.gl.uniform1i(this.locations.pano, 0);
        this.gl.uniform1f(this.locations.yaw, this.yaw);
        this.gl.uniform1f(this.locations.pitch, this.pitch);
        this.gl.uniform1f(this.locations.fov, this.fov);
        this.gl.uniform1f(this.locations.aspect, width / height);
        this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
        this.onViewChange?.();
      }
      project(yaw, pitch) {
        const world = { x: Math.sin(yaw) * Math.cos(pitch), y: Math.sin(pitch), z: -Math.cos(yaw) * Math.cos(pitch) };
        const camera = rotateX(rotateY(world, -this.yaw), -this.pitch);
        if (camera.z >= -.05) return null;
        const rect = this.canvas.getBoundingClientRect();
        const tan = Math.tan(this.fov / 2);
        const nx = (camera.x / -camera.z) / (tan * (rect.width / rect.height));
        const ny = (camera.y / -camera.z) / tan;
        if (Math.abs(nx) > 1.2 || Math.abs(ny) > 1.2) return null;
        return { x: (nx + 1) * .5 * rect.width, y: (1 - (ny + 1) * .5) * rect.height };
      }
    }

    const initialize = root => {
      if (root.dataset.dteReady === 'true') return;
      root.dataset.dteReady = 'true';
      const data = JSON.parse(root.querySelector('[data-dte-data]').textContent);
      const position = value => {
        const parts = String(value || '0, 0').split(',').map(Number);
        return parts.length === 2 && parts.every(Number.isFinite) ? [((parts[0] + 180) % 360 + 360) % 360 - 180, clamp(parts[1], -85, 85)] : [0, 0];
      };
      data.rooms = [];
      data.hotspots = [];
      root.querySelectorAll('[data-dte-room-block]').forEach(element => {
        const view = JSON.parse(element.querySelector('[data-dte-room]').textContent);
        const [yaw, pitch] = position(view.openingPosition);
        view.startYaw = -yaw;
        view.startPitch = pitch;
        data.rooms.push(view);
        element.querySelectorAll('[data-dte-point]').forEach(script => {
          const point = JSON.parse(script.textContent);
          const [yaw, pitch] = position(point.position);
          data.hotspots.push({ ...point, room: view.id, yaw, pitch });
        });
      });
      const canvas = root.querySelector('.dte__canvas');
      const markersLayer = root.querySelector('.dte__markers');
      const loading = root.querySelector('[data-dte-loading]');
      const loadingText = root.querySelector('[data-dte-loading-text]');
      const dialog = root.querySelector('[data-dte-dialog]');
      const dialogContent = root.querySelector('[data-dte-dialog-content]');
      const discovered = new Set();
      let room = data.rooms[0];
      let activeHotspots = [];
      let loadedRoomId = '';
      let renderer;
      let dialogScrollPosition;
      let editorSelection = null;
      let loadSequence = 0;
      dialog.addEventListener('close', () => {
        const position = dialogScrollPosition;
        dialogScrollPosition = null;
        if (position) requestAnimationFrame(() => window.scrollTo({ ...position, behavior: 'instant' }));
      });

      const openDialog = content => {
        if (!dialog.open) dialogScrollPosition = { left: window.scrollX, top: window.scrollY };
        dialogContent.replaceChildren(content);
        dialog.showModal();
        dialogContent.querySelector('[data-dte-continue]')?.addEventListener('click', closeDialog);
      };
      const closeDialog = () => {
        dialogContent.querySelectorAll('video').forEach(video => video.pause());
        if (dialog.open) dialog.close();
      };
      const cloneTemplate = template => template.content.cloneNode(true);
      const updateMarkers = () => {
        const positionField = root.querySelector('[data-dte-position]');
        if (positionField && renderer) {
          const yaw = ((-renderer.yaw / DEG + 180) % 360 + 360) % 360 - 180;
          positionField.value = `${yaw.toFixed(1)}, ${(renderer.pitch / DEG).toFixed(1)}`;
        }
        markersLayer.querySelectorAll('[data-hotspot-id]').forEach(marker => {
          const hotspot = activeHotspots.find(item => item.id === marker.dataset.hotspotId);
          const point = renderer.project(Number(hotspot.yaw) * DEG, Number(hotspot.pitch) * DEG);
          marker.hidden = !point;
          if (point) {
            marker.style.left = `${point.x}px`;
            marker.style.top = `${point.y}px`;
          }
        });
      };
      const updateProgress = () => {
        const stories = activeHotspots.filter(item => item.type === 'story');
        const count = stories.filter(item => discovered.has(item.id)).length;
        root.querySelector('[data-dte-explore]').hidden = stories.length === 0;
        root.querySelector('.dte__progress').hidden = stories.length === 0;
        root.querySelector('[data-dte-progress]').textContent = data.labels.discovered.replace('[count]', count).replace('[total]', stories.length);
        root.querySelector('[data-dte-count]').textContent = stories.length - count;
      };
      const showStory = hotspot => {
        discovered.add(hotspot.id);
        updateProgress();
        const template = root.querySelector(`[data-dte-story-template="${CSS.escape(hotspot.id)}"]`);
        if (template) openDialog(cloneTemplate(template));
      };
      const iconPaths = {"pin": "M12 22s7-7 7-13a7 7 0 1 0-14 0c0 6 7 13 7 13Z M15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0", "info": "M12 11v6 M12 7h.01 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0", "play": "M9 7l8 5-8 5Z M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0", "glass": "M7 3h10l1 6a6 6 0 0 1-12 0Z M12 15v6 M8 21h8 M6 9h12", "cask": "M6 3Q1 12 6 21h12q5-9 0-18Z M4 7h16 M4 17h16 M9 3q-3 9 0 18 M15 3q3 9 0 18", "camera": "M3 6h4l2-3h6l2 3h4v15H3Z M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0", "arrow_left": "M20 12H4 M10 6l-6 6 6 6", "arrow_up": "M12 20V4 M6 10l6-6 6 6"};
      const makeMarkerIcon = hotspot => {
        const icon = document.createElement('span');
        icon.className = 'dte__marker-icon';
        icon.setAttribute('aria-hidden', 'true');
        const useShared = data.forceSharedIcon === true || ((!hotspot.icon || hotspot.icon === 'default') && !hotspot.iconImage);
        const choice = useShared ? data.sharedIcon : hotspot.icon;
        const selected = !choice || choice === 'default' ? (hotspot.type === 'doorway' ? 'arrow' : 'sparkle') : choice;
        const iconImage = useShared ? data.sharedIconImage : hotspot.iconImage;
        const drawBuiltin = () => {
          icon.replaceChildren();
          if (iconPaths[selected]) {
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('focusable', 'false');
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            path.setAttribute('d', iconPaths[selected]);
            svg.append(path);
            icon.append(svg);
          } else {
            icon.textContent = selected === 'arrow' ? '➜' : '✦';
          }
        };
        drawBuiltin();
        if (iconImage) {
          const image = document.createElement('img');
          image.alt = '';
          image.width = 23;
          image.height = 23;
          image.addEventListener('error', drawBuiltin, { once: true });
          image.src = iconImage;
          icon.replaceChildren(image);
        }
        return icon;
      };
      const drawMarkers = () => {
        activeHotspots = data.hotspots.filter(item => item.room === room.id && item.enabled !== false);
        markersLayer.replaceChildren();
        activeHotspots.forEach(hotspot => {
          const marker = document.createElement('button');
          marker.type = 'button';
          marker.className = `dte__marker${hotspot.type === 'doorway' ? ' dte__marker--door' : ''}`;
          marker.dataset.hotspotId = hotspot.id;
          marker.classList.toggle('dte__marker--selected', hotspot.id === editorSelection);
          marker.setAttribute('aria-label', hotspot.label);
          if (hotspot.iconColor) marker.style.setProperty('--dte-point-icon-color', hotspot.iconColor);
          if (hotspot.iconBackground) marker.style.setProperty('--dte-point-icon-background', hotspot.iconBackground);
          const label = document.createElement('span');
          label.className = 'dte__marker-label';
          label.textContent = hotspot.label;
          marker.append(makeMarkerIcon(hotspot), label);
          marker.addEventListener('click', () => hotspot.type === 'doorway' ? goToRoom(hotspot.target) : showStory(hotspot));
          markersLayer.append(marker);
        });
        updateMarkers();
        updateProgress();
      };
      const goToRoom = async id => {
        const next = data.rooms.find(item => item.id === id);
        if (!next) return;
        if (next.id === loadedRoomId) return closeDialog();
        closeDialog();
        room = next;
        const sequence = ++loadSequence;
        const roomSelect = root.querySelector('[data-dte-editor-room]');
        if (roomSelect) roomSelect.value = room.id;
        root.querySelector('[data-dte-title]').textContent = room.title;
        root.querySelector('[data-dte-subtitle]').textContent = room.subtitle;
        root.querySelector('[data-dte-index]').textContent = data.labels.roomIndex.replace('[current]', data.rooms.indexOf(room) + 1).replace('[total]', data.rooms.length);
        loading.hidden = false;
        loadingText.textContent = root.dataset.loadingLabel;
        if (!room.image) {
          loadingText.textContent = root.dataset.imageMissingLabel;
          markersLayer.replaceChildren();
          return;
        }
        try {
          await renderer.load(room.image, room.startYaw, room.startPitch);
          if (sequence !== loadSequence) return;
          loadedRoomId = next.id;
          loading.hidden = true;
          drawMarkers();
        } catch {
          loadingText.textContent = root.dataset.imageMissingLabel;
        }
      };
      const makeChoiceList = (heading, choices) => {
        const fragment = document.createDocumentFragment();
        const eyebrow = document.createElement('p');
        eyebrow.className = 'dte__panel-eyebrow';
        eyebrow.textContent = heading;
        fragment.append(eyebrow);
        const list = document.createElement('div');
        list.className = 'dte__choice-list';
        choices.forEach((choice, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dte__choice';
          button.innerHTML = `<span class="dte__choice-number">${String(index + 1).padStart(2, '0')}</span><span class="dte__choice-name"></span><span class="dte__choice-status">${choice.status}</span>`;
          button.querySelector('.dte__choice-name').textContent = choice.label;
          button.addEventListener('click', choice.action);
          list.append(button);
        });
        fragment.append(list);
        return fragment;
      };

      try {
        renderer = new PanoramaRenderer(canvas, updateMarkers);
      } catch {
        loadingText.textContent = root.dataset.imageMissingLabel;
        return;
      }
      if (!room) {
        loadingText.textContent = root.dataset.imageMissingLabel;
        return;
      }
      root.querySelector('[data-dte-close]').addEventListener('click', closeDialog);
      dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); });
      root.querySelector('[data-dte-about]').addEventListener('click', () => openDialog(cloneTemplate(root.querySelector('[data-dte-about-template]'))));
      root.querySelector('[data-dte-rooms]').addEventListener('click', () => openDialog(makeChoiceList(data.labels.chooseRoom, data.rooms.map(item => ({ label: item.title, status: item === room ? '●' : '↗', action: () => goToRoom(item.id) })))));
      root.querySelector('[data-dte-explore]').addEventListener('click', () => {
        const stories = activeHotspots.filter(item => item.type === 'story');
        openDialog(makeChoiceList(data.labels.chooseStory, stories.map(item => ({ label: item.label, status: discovered.has(item.id) ? '✓' : '↗', action: () => showStory(item) }))));
      });
      if (root.dataset.editor === 'true') {
        const tools = root.querySelector('[data-dte-editor]');
        const roomSelect = tools.querySelector('[data-dte-editor-room]');
        const status = tools.querySelector('[data-dte-editor-status]');
        const aim = tools.querySelector('[data-dte-aim]');
        const state = editorStates.get(root.dataset.sectionId) || { open: false, aim: false };
        editorStates.set(root.dataset.sectionId, state);
        tools.querySelector('details').open = state.open;
        aim.checked = state.aim;
        root.querySelector('[data-dte-crosshair]').hidden = !state.aim;
        tools.querySelector('details').addEventListener('toggle', event => { state.open = event.target.open; });
        data.rooms.forEach(view => {
          const option = document.createElement('option');
          option.value = view.id;
          option.textContent = view.title;
          roomSelect.append(option);
        });
        roomSelect.addEventListener('change', () => goToRoom(roomSelect.value));
        aim.addEventListener('change', () => { state.aim = aim.checked; root.querySelector('[data-dte-crosshair]').hidden = !aim.checked; });
        const copy = async (text, message) => {
          const field = tools.querySelector('[data-dte-position]');
          try { await navigator.clipboard.writeText(text); status.textContent = message; }
          catch { field.value = text; field.focus(); field.select(); status.textContent = 'Select and copy this value, then paste it into the sidebar.'; }
        };
        tools.querySelector('[data-dte-copy-position]').addEventListener('click', () => copy(tools.querySelector('[data-dte-position]').value, 'Position copied. Paste it into Position or Opening view, then Save.'));
        tools.querySelector('[data-dte-copy-key]').addEventListener('click', () => copy(room.id, 'Viewpoint key copied. Choose Another viewpoint in the navigation point and paste into Destination key.'));
        const missing = data.hotspots.filter(point => point.type === 'doorway' && point.enabled !== false && !data.rooms.some(view => view.id === point.target));
        const noImages = data.rooms.filter(view => !view.image);
        const invalidPositions = data.hotspots.filter(point => !/^\s*-?\d+(?:\.\d+)?\s*,\s*-?\d+(?:\.\d+)?\s*$/.test(point.position || ''));
        const duplicates = data.rooms.filter((view, index) => data.rooms.findIndex(other => other.id === view.id) !== index);
        tools.querySelector('[data-dte-editor-warning]').textContent = [invalidPositions.length ? `${invalidPositions.length} point position(s) need two numbers separated by a comma, for example 90, -12.` : '', missing.length ? `${missing.length} navigation point(s) need a valid destination.` : '', noImages.length ? `${noImages.length} viewpoint(s) need a panorama.` : '', duplicates.length ? 'Some viewpoints share a key. Give them unique keys under Advanced.' : ''].filter(Boolean).join(' ');
        root.addEventListener('shopify:block:select', async event => {
          const id = event.detail.blockId;
          const point = data.hotspots.find(item => item.id === id);
          const view = point ? data.rooms.find(item => item.id === point.room) : data.rooms.find(item => item.blockId === id);
          if (!view) return;
          editorSelection = point?.id || null;
          await goToRoom(view.id);
          if (point) {
            renderer.yaw = -point.yaw * DEG;
            renderer.pitch = point.pitch * DEG;
            renderer.render();
            markersLayer.querySelectorAll('[data-hotspot-id]').forEach(marker => marker.classList.toggle('dte__marker--selected', marker.dataset.hotspotId === point.id));
          }
          if (!point) {
            renderer.yaw = view.startYaw * DEG;
            renderer.pitch = view.startPitch * DEG;
            renderer.render();
          }
          status.textContent = point ? `Editing: ${point.label}${point.enabled === false ? ' (hidden)' : ''}. Centre the object, copy its position, then paste and Save.` : `Editing viewpoint: ${view.title}. Its points are nested below it in the sidebar.`;
        });
      }
      goToRoom(room.id);
      root.addEventListener('shopify:section:unload', () => { renderer.resizeObserver.disconnect(); renderer.gl.getExtension('WEBGL_lose_context')?.loseContext(); }, { once: true });
    };

    document.querySelectorAll('[data-distillery-experience]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => {
      if (event.target.matches?.('[data-distillery-experience]')) initialize(event.target);
      event.target.querySelectorAll?.('[data-distillery-experience]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initScHeaderHoverMenus(scope = document) {
    const headers = scope.querySelectorAll('.sc-header--menu-open-hover');

    headers.forEach((header) => {
      header.querySelectorAll('header-menu > details').forEach((details) => {
        if (details.dataset.scHoverReady === 'true') return;
        details.dataset.scHoverReady = 'true';

        const summary = details.querySelector('summary');

        details.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          details.setAttribute('open', '');
          summary?.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          if (details.contains(document.activeElement)) return;
          details.removeAttribute('open');
          summary?.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  initScHeaderHoverMenus();
  document.addEventListener('shopify:section:load', (event) => initScHeaderHoverMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-campaign-canvas"] && !Shopify.designMode) return;
  try {
    
  class ScCampaignCanvas extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-sc-campaign-video-toggle]').forEach((button) => {
        if (button.dataset.ready === 'true') return;
        const panel = button.closest('.sc-campaign-mosaic__media, .sc-campaign-video-panel');
        const video = panel?.querySelector('video');
        if (!video) return;
        button.dataset.ready = 'true';
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            button.setAttribute('aria-label', 'Pause video');
            button.querySelector('[data-sc-campaign-video-label]').textContent = 'Pause';
          } else {
            video.pause();
            button.setAttribute('aria-label', 'Play video');
            button.querySelector('[data-sc-campaign-video-label]').textContent = 'Play';
          }
        });
      });

      this.querySelectorAll('[data-sc-campaign-row-play]').forEach((button) => {
        if (button.dataset.ready === 'true') return;
        const video = button.closest('.sc-campaign-media-row__item')?.querySelector('video');
        const label = button.querySelector('[data-sc-campaign-row-play-label]');
        if (!video) return;
        button.dataset.ready = 'true';

        const update = () => {
          const playing = !video.paused;
          button.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
          if (label) label.textContent = playing ? 'Pause' : 'Play';
        };

        button.addEventListener('click', () => {
          if (video.paused) video.play();
          else video.pause();
        });
        video.addEventListener('play', update);
        video.addEventListener('pause', update);
        update();
      });

      this.querySelectorAll('[data-sc-campaign-row-sound]').forEach((button) => {
        if (button.dataset.ready === 'true') return;
        const video = button.closest('.sc-campaign-media-row__item')?.querySelector('video');
        const label = button.querySelector('[data-sc-campaign-row-sound-label]');
        if (!video) return;
        button.dataset.ready = 'true';

        const update = () => {
          button.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
          if (label) label.textContent = video.muted ? 'Sound on' : 'Sound off';
        };

        button.addEventListener('click', () => {
          video.muted = !video.muted;
          update();
        });
        update();
      });
    }
  }

  if (!customElements.get('sc-campaign-canvas')) {
    customElements.define('sc-campaign-canvas', ScCampaignCanvas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-customer-preferences"] && !Shopify.designMode) return;
  try {
    
  class ScCustomerPreferences extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-sc-customer-preferences-form]');
      this.fields = Array.from(this.querySelectorAll('[data-sc-preference-field]'));
      this.status = this.querySelector('[data-sc-preferences-status]');
      this.submit = this.querySelector('[data-sc-preferences-submit]');
      this.openConfirm = this.querySelector('[data-sc-preferences-open-confirm]');
      this.confirmPanel = this.querySelector('[data-sc-preferences-confirm]');
      this.cancelConfirm = this.querySelector('[data-sc-preferences-cancel]');
      this.defaultSubmitLabel = this.submit?.textContent.trim() || '';
      this.profile = null;

      this.submitHandler = (event) => {
        event.preventDefault();
        this.save();
      };
      this.openHandler = () => {
        if (this.confirmPanel) this.confirmPanel.hidden = false;
        if (this.openConfirm) this.openConfirm.hidden = true;
        this.submit?.focus();
      };
      this.cancelHandler = () => {
        if (this.confirmPanel) this.confirmPanel.hidden = true;
        if (this.openConfirm) this.openConfirm.hidden = false;
        this.openConfirm?.focus();
      };
      this.form?.addEventListener('submit', this.submitHandler);
      this.openConfirm?.addEventListener('click', this.openHandler);
      this.cancelConfirm?.addEventListener('click', this.cancelHandler);
      if (this.dataset.endpoint) this.load();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.submitHandler);
      this.openConfirm?.removeEventListener('click', this.openHandler);
      this.cancelConfirm?.removeEventListener('click', this.cancelHandler);
    }

    valueAt(source, path) {
      if (!path) return undefined;
      return path.split('.').reduce((value, key) => (value == null ? undefined : value[key]), source);
    }

    converted(value, type) {
      if (type === 'boolean') return String(value).toLowerCase() === 'true';
      if (type === 'number') return Number(value);
      return value == null ? '' : String(value);
    }

    populate(profile) {
      this.profile = profile || {};
      this.fields.forEach((field) => {
        if (field.dataset.fieldKind === 'hidden' && field.dataset.useLoadedValue !== 'true') return;
        const value = this.valueAt(this.profile, field.dataset.valuePath);
        if (value === undefined || value === null) {
          if (field.dataset.fallback !== undefined) field.value = field.dataset.fallback;
          return;
        }
        if (field.dataset.fieldKind === 'checkbox') field.checked = Boolean(value);
        else field.value = value;
      });
    }

    payload() {
      const payload = {};
      this.fields.forEach((field) => {
        const key = field.dataset.payloadKey;
        if (!key) return;
        if (field.dataset.fieldKind === 'checkbox') payload[key] = field.checked;
        else payload[key] = this.converted(field.value, field.dataset.valueType);
      });
      return payload;
    }

    setStatus(message, error = false) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.classList.toggle('is-error', error);
    }

    setBusy(busy) {
      this.form?.setAttribute('aria-busy', String(busy));
      this.fields.forEach((field) => { field.disabled = busy; });
      if (this.openConfirm) this.openConfirm.disabled = busy;
      if (this.submit) {
        this.submit.disabled = busy;
        this.submit.textContent = busy ? (this.dataset.savingLabel || 'Saving...') : this.defaultSubmitLabel;
      }
    }

    async response(request, fallbackMessage) {
      const response = await request;
      const data = await response.json();
      if (!response.ok || data?.ok === false) throw new Error(data?.message || fallbackMessage || 'Request failed');
      return data;
    }

    async load() {
      this.setBusy(true);
      this.setStatus(this.dataset.loadingLabel || 'Loading your details...');
      try {
        const data = await this.response(fetch(this.dataset.endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }), this.dataset.loadErrorLabel);
        this.populate(this.valueAt(data, this.dataset.responsePath) || data);
        this.setStatus('');
      } catch (error) {
        this.setStatus(error.message || this.dataset.loadErrorLabel || 'We could not load these details just now.', true);
      } finally {
        this.setBusy(false);
      }
    }

    async save() {
      if (!this.dataset.endpoint || !this.form?.reportValidity()) return;
      this.setBusy(true);
      this.setStatus('');
      try {
        const data = await this.response(fetch(this.dataset.endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(this.payload()),
        }), this.dataset.saveErrorLabel);
        this.populate(this.valueAt(data, this.dataset.responsePath) || data);
        this.setStatus(this.dataset.successLabel || 'Your changes have been saved.');
        if (this.dataset.redirectUrl) {
          window.setTimeout(() => window.location.assign(this.dataset.redirectUrl), 500);
        } else if (this.dataset.reloadSuccess === 'true') {
          window.setTimeout(() => window.location.reload(), 500);
        } else {
          this.setBusy(false);
        }
      } catch (error) {
        this.setStatus(error.message || this.dataset.saveErrorLabel || 'We could not save your changes.', true);
        this.setBusy(false);
      }
    }
  }

  if (!customElements.get('sc-customer-preferences')) {
    customElements.define('sc-customer-preferences', ScCustomerPreferences);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-customer-records"] && !Shopify.designMode) return;
  try {
    
  class ScCustomerRecords extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.status = this.querySelector('[data-sc-customer-records-status]');
      this.list = this.querySelector('[data-sc-customer-records-list]');
      this.config = this.readConfig();
      this.load();
    }

    readConfig() {
      try {
        return JSON.parse(this.querySelector('[data-sc-customer-records-config]')?.textContent || '{}');
      } catch (_error) {
        return {};
      }
    }

    async load() {
      const previewRecords = this.parsePreviewRecords();
      if (previewRecords) {
        if (!previewRecords.length) {
          this.showState(this.config.emptyText, 'empty');
          return;
        }
        this.render(previewRecords);
        return;
      }

      if (!this.config.endpoint) {
        this.showState(this.config.emptyText || 'No records are connected yet.', 'empty');
        return;
      }

      try {
        const response = await fetch(this.config.endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Request failed');
        const payload = await response.json();
        const records = this.normaliseRecords(this.getPath(payload, this.config.recordsPath));
        if (!records.length) {
          this.showState(this.config.emptyText, 'empty');
          return;
        }
        this.render(records);
      } catch (_error) {
        this.showState(this.config.errorText, 'error');
      }
    }

    normaliseRecords(value) {
      if (Array.isArray(value)) return value;
      if (value && typeof value === 'object') return [value];
      return [];
    }

    parsePreviewRecords() {
      if (!this.config.previewRecords) return null;
      try {
        return this.normaliseRecords(JSON.parse(this.config.previewRecords));
      } catch (_error) {
        return [];
      }
    }

    getPath(value, path) {
      if (!path) return value;
      return String(path).split('.').reduce((current, part) => {
        if (current == null) return undefined;
        return current[part];
      }, value);
    }

    showState(message, state) {
      if (this.status) {
        this.status.textContent = message || '';
        this.status.dataset.state = state;
      }
      if (state === 'empty' && this.dataset.hideEmpty === 'true') {
        this.closest('.sc-customer-records')?.setAttribute('hidden', '');
      }
    }

    render(records) {
      const fragment = document.createDocumentFragment();
      records.forEach((record) => fragment.appendChild(this.renderCard(record)));
      this.list.replaceChildren(fragment);
      this.list.hidden = false;
      this.status.hidden = true;
    }

    renderCard(record) {
      const article = this.element('article', 'sc-customer-records__card sc-reveal is-visible');
      const imageUrl = this.getPath(record, this.config.imagePath) || this.config.fallbackImage;
      if (imageUrl) {
        const media = this.element('div', 'sc-customer-records__media');
        const image = document.createElement('img');
        image.src = String(imageUrl);
        image.alt = this.config.fallbackAlt || '';
        image.loading = 'lazy';
        media.appendChild(image);
        article.appendChild(media);
      }

      const content = this.element('div', 'sc-customer-records__content');
      const eyebrow = this.getPath(record, this.config.eyebrowPath);
      if (eyebrow) content.appendChild(this.textElement('p', 'sc-customer-records__eyebrow', eyebrow));

      const title = this.getPath(record, this.config.titlePath) || this.config.fallbackTitle;
      content.appendChild(this.textElement('h3', 'sc-customer-records__title', title || 'Record'));

      const description = this.getPath(record, this.config.descriptionPath);
      if (description) content.appendChild(this.textElement('p', 'sc-customer-records__description', description));

      const summaries = [
        [this.config.primaryLabel, this.getPath(record, this.config.primaryPath)],
        [this.config.secondaryLabel, this.getPath(record, this.config.secondaryPath)],
      ].filter((item) => item[0] && item[1] != null && item[1] !== '');
      if (summaries.length) {
        const summary = this.element('div', 'sc-customer-records__summary');
        summaries.forEach(([label, value]) => {
          const item = this.element('div', 'sc-customer-records__summary-item');
          item.append(this.textElement('span', '', label), this.textElement('strong', '', this.format(value, 'text')));
          summary.appendChild(item);
        });
        content.appendChild(summary);
      }

      const details = this.parseDetailFields()
        .map((field) => ({ ...field, value: this.getPath(record, field.path) }))
        .filter((field) => field.value != null && field.value !== '');
      if (details.length) content.appendChild(this.renderDetails(details));

      const link = this.getPath(record, this.config.linkPath);
      if (link && this.config.linkLabel) {
        const anchor = this.textElement('a', 'sc-customer-records__link', this.config.linkLabel);
        anchor.href = String(link);
        content.appendChild(anchor);
      }

      article.appendChild(content);
      return article;
    }

    renderDetails(fields) {
      const details = this.element('details', 'sc-customer-records__details');
      details.appendChild(this.textElement('summary', '', this.config.detailsLabel || 'View details'));
      const list = this.element('dl', 'sc-customer-records__detail-list');
      fields.forEach((field) => {
        const row = this.element('div', 'sc-customer-records__detail');
        row.append(this.textElement('dt', '', field.label), this.textElement('dd', '', this.format(field.value, field.format)));
        list.appendChild(row);
      });
      details.appendChild(list);
      return details;
    }

    parseDetailFields() {
      return String(this.config.detailFields || '')
        .split('\n')
        .map((line) => {
          const [label, path, format = 'text'] = line.split('|').map((part) => part.trim());
          return { label, path, format };
        })
        .filter((field) => field.label && field.path);
    }

    format(value, format) {
      if (format === 'date') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
      }
      if (format === 'number') {
        const number = Number(value);
        if (!Number.isNaN(number)) return new Intl.NumberFormat().format(number);
      }
      if (Array.isArray(value)) return value.join(', ');
      if (value && typeof value === 'object') return Object.values(value).filter(Boolean).join(', ');
      return String(value);
    }

    element(tag, className) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      return element;
    }

    textElement(tag, className, value) {
      const element = this.element(tag, className);
      element.textContent = value == null ? '' : String(value);
      return element;
    }
  }

  if (!customElements.get('sc-customer-records')) {
    customElements.define('sc-customer-records', ScCustomerRecords);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-dads-hat-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ATTRIBUTE_NAME = 'Dad’s Hat additional bottle interest';
    const ALLOWED_INTEREST = new Set(['1', '2']);
    const ACTIVE_STATE = 'eligible';

    const normalizeInterest = (value) => {
      const normalized = String(value ?? '');
      return ALLOWED_INTEREST.has(normalized) ? normalized : null;
    };

    const buildLine = ({ variantId, interest, quantity, state, maxQuantity = 1 }) => {
      const normalizedInterest = normalizeInterest(interest);
      if (state !== ACTIVE_STATE) return { ok: false, code: 'state_closed' };
      if (!/^\d+$/.test(String(variantId ?? ''))) return { ok: false, code: 'invalid_variant' };
      const selectedQuantity = Number(quantity);
      if (!Number.isInteger(selectedQuantity) || selectedQuantity < 1 || selectedQuantity > Number(maxQuantity)) {
        return { ok: false, code: 'invalid_quantity' };
      }
      if (String(interest ?? '') !== '' && normalizedInterest === null) {
        return { ok: false, code: 'invalid_interest' };
      }
      return {
        ok: true,
        line: {
          offer: 'dads_hat_preview',
          id: String(variantId),
          quantity: selectedQuantity,
          properties: {}
        }
      };
    };

    const createSubmissionGate = () => {
      let busy = false;
      return {
        start() {
          if (busy) return false;
          busy = true;
          return true;
        },
        finish() {
          busy = false;
        },
        isBusy() {
          return busy;
        }
      };
    };

    const findBottle = (cart, variantId, maxQuantity = 1) => {
      if (!cart || !Array.isArray(cart.items)) throw new Error('malformed_cart');
      const matches = cart.items.filter((line) => String(line.variant_id ?? line.id) === String(variantId));
      if (matches.length > 1) throw new Error('split_lines');
      const line = matches[0];
      if (line && (!Number.isInteger(Number(line.quantity)) || Number(line.quantity) < 1 || Number(line.quantity) > Number(maxQuantity) || !line.key || line.selling_plan_allocation)) {
        throw new Error('altered_line');
      }
      if (line && line.properties != null && (typeof line.properties !== 'object' || Array.isArray(line.properties))) {
        throw new Error('invalid_properties');
      }
      return line;
    };

    const readInterest = (cart) => {
      if (!cart || !cart.attributes || typeof cart.attributes !== 'object' || Array.isArray(cart.attributes)) {
        throw new Error('malformed_attributes');
      }
      if (!Object.hasOwn(cart.attributes, ATTRIBUTE_NAME)) return '';
      const value = cart.attributes[ATTRIBUTE_NAME];
      if (typeof value !== 'string') throw new Error('malformed_interest');
      return value;
    };

    const createCartJourney = ({ variantId, maxQuantity = 1, readCart, addOne, updateInterest }) => {
      let addAttempted = false;
      let added = false;
      let busy = false;
      let uncertain = false;
      const exclusive = async (operation) => {
        if (busy) throw new Error('journey_busy');
        if (uncertain) throw new Error('check_basket_before_retry');
        busy = true;
        try { return await operation(); } finally { busy = false; }
      };
      const inspect = (cart, required = false) => {
        const line = findBottle(cart, variantId, maxQuantity);
        readInterest(cart);
        if (required && !line) throw new Error('missing_line');
        return line;
      };
      const writeInterest = async (interest, required) => {
        let response;
        let responseReceived = false;
        let failure;
        try {
          response = await updateInterest({ attributes: { [ATTRIBUTE_NAME]: interest } });
          responseReceived = true;
        } catch (error) {
          if (error?.code === 'interest_display_not_saved') {
            uncertain = true;
            throw error;
          }
        }
        if (responseReceived) {
          try {
            inspect(response, required);
            if (readInterest(response) !== interest) throw new Error('interest_not_saved');
          } catch (error) { failure = error; }
        }
        let cart;
        try {
          cart = await readCart();
          inspect(cart, required);
          if (readInterest(cart) !== interest) throw new Error('interest_not_saved');
        } catch (error) { failure ||= error; }
        if (failure) {
          uncertain = true;
          throw failure;
        }
        return { line: inspect(cart, required), interest: readInterest(cart) };
      };
      return {
        add(quantity = 1) {
          return exclusive(async () => {
            let cart = await readCart();
            let line = inspect(cart);
            const existing = Boolean(line);
            if (!added && readInterest(cart) !== '') {
              await writeInterest('', existing);
              cart = await readCart();
              line = inspect(cart);
            }
            if (!line) {
              if (addAttempted) throw new Error('check_basket_before_retry');
              addAttempted = true;
              try { await addOne({ items: [{ id: variantId, quantity }] }); } catch (error) {
                line = inspect(await readCart());
                if (!line) throw error;
              }
              line = inspect(await readCart(), true);
            }
            if (!line) throw new Error('missing_line');
            added = true;
            return { line, existing };
          });
        },
        save(interest) {
          return exclusive(async () => {
            if (!added) throw new Error('not_added');
            if (typeof interest !== 'string' || (interest !== '' && normalizeInterest(interest) === null)) {
              throw new Error('invalid_interest');
            }
            try {
              inspect(await readCart(), true);
            } catch (error) {
              uncertain = true;
              throw error;
            }
            return writeInterest(interest, true);
          });
        }
      };
    };

    const createAjaxTransport = (cartUrl, addUrl, variantId, maxQuantity, interestLabels) => {
      const request = async (url, body) => {
        const controller = new AbortController();
        let timeout;
        const deadline = new Promise((resolve, reject) => {
          timeout = setTimeout(() => {
            reject(new Error('cart_request_timeout'));
            controller.abort();
          }, 15000);
        });
        try {
          const operation = async () => {
            const response = await fetch(url, {
              method: body ? 'POST' : 'GET',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              ...(body ? { body: JSON.stringify(body) } : {}),
              signal: controller.signal
            });
            if (!response.ok) throw new Error('cart_request_failed');
            return await response.json();
          };
          return await Promise.race([operation(), deadline]);
        } finally {
          clearTimeout(timeout);
        }
      };
      return {
        readCart: () => request(cartUrl + '.js'),
        addOne: (body) => request(addUrl + '.js', body),
        updateInterest: async (body) => {
          const interest = body.attributes[ATTRIBUTE_NAME];
          const expectedDisplay = interest === '1' || interest === '2'
            ? `${interestLabels[interest]} — ${interestLabels.note}` : '';
          try {
            let cart = await request(cartUrl + '.js');
            const line = findBottle(cart, variantId, maxQuantity);
            if (line && String(line.properties?.['Additional bottle interest'] || '') !== expectedDisplay) {
              const properties = { ...line.properties, 'Additional bottle interest': expectedDisplay };
              try {
                await request(cartUrl + '/change.js', { id: line.key, quantity: line.quantity, properties });
              } catch {}
              cart = await request(cartUrl + '.js');
              const updated = findBottle(cart, variantId, maxQuantity);
              if (!updated || String(updated.properties?.['Additional bottle interest'] || '') !== expectedDisplay) {
                throw new Error('interest_display_not_saved');
              }
            }
          } catch (error) {
            error.code = 'interest_display_not_saved';
            throw error;
          }
          return request(cartUrl + '/update.js', body);
        }
      };
    };

    const createSyntheticTransport = (scenario) => {
      let cart = { items: [], attributes: {} };
      return {
        readCart: async () => JSON.parse(JSON.stringify(cart)),
        async addOne(body) {
          await new Promise((resolve) => setTimeout(resolve, 80));
          if (scenario === 'request_failure') throw new Error('synthetic_request_failure');
          const line = { ...body.items[0], key: 'preview:one', properties: {} };
          cart = { ...cart, items: [line] };
          if (scenario === 'malformed_response') cart = { items: 'invalid' };
          if (scenario === 'altered_line') line.quantity = 2;
          if (scenario === 'split_lines') cart.items.push({ ...line });
          return cart;
        },
        async updateInterest(body) {
          await new Promise((resolve) => setTimeout(resolve, 80));
          if (scenario === 'interest_failure') throw new Error('synthetic_interest_failure');
          cart.attributes = { ...cart.attributes, ...body.attributes };
          return cart;
        }
      };
    };

    class SCDadsHatOffer extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-sc-dads-hat-form]');
        if (!this.form || this.initialized || this.dataset.state !== ACTIVE_STATE) return;
        this.initialized = true;
        this.submitButton = this.querySelector('[data-sc-dads-hat-submit]');
        this.acknowledgement = this.querySelector('[data-sc-dads-hat-acknowledgement]');
        this.submitLabel = this.querySelector('[data-sc-dads-hat-submit-label]');
        this.continueButton = this.querySelector('[data-sc-dads-hat-continue]');
        this.nextStep = this.querySelector('[data-sc-dads-hat-next-step]');
        this.confirmation = this.querySelector('[data-sc-dads-hat-confirmation]');
        this.fieldset = this.querySelector('[data-sc-dads-hat-interest]');
        this.recovery = this.querySelector('[data-sc-dads-hat-recovery]');
        this.status = this.querySelector('[data-sc-dads-hat-status]');
        this.evidence = this.querySelector('[data-sc-dads-hat-evidence]');
        this.interestInputs = [...this.querySelectorAll('input[name="dads_hat_interest"]')];
        this.cancelInterestButton = this.querySelector('[data-sc-dads-hat-interest-cancel]');
        this.interestInputs.forEach((input) => input.addEventListener('change', () => {
          this.currentInterest = input.value;
          this.announce('');
        }));
        this.cancelInterestButton?.addEventListener('click', () => this.cancelInterest());
        const variantId = new FormData(this.form).get('id');
        const transport = this.dataset.synthetic === 'true'
          ? createSyntheticTransport(this.dataset.scenario)
          : createAjaxTransport(this.dataset.cartUrl, this.form.action, variantId, Number(this.dataset.maxQuantity) || 1, {
              '1': this.dataset.interestOneDisplay,
              '2': this.dataset.interestTwoDisplay,
              note: this.dataset.interestDisplayNote
            });
        this.journey = createCartJourney({ variantId, maxQuantity: Number(this.dataset.maxQuantity) || 1, ...transport });
        this.gate = createSubmissionGate();
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
        if (this.dataset.synthetic === 'true') {
          this.submitButton.addEventListener('click', (event) => this.handleSubmit(event));
        }
        this.continueButton.addEventListener('click', (event) => this.handleSubmit(event, true));
        this.acknowledgement?.addEventListener('change', () => {
          this.setBusy(Boolean(this.busy));
          this.announce('');
        });
        if (typeof window.addEventListener === 'function') {
          this.onPageShow = () => this.setBusy(false);
          window.addEventListener('pageshow', this.onPageShow);
        }
        this.setBusy(false);
      }

      disconnectedCallback() {
        if (this.onPageShow && typeof window.removeEventListener === 'function') {
          window.removeEventListener('pageshow', this.onPageShow);
        }
      }

      cancelInterest() {
        this.interestInputs.forEach((input) => { input.checked = false; });
        this.currentInterest = '';
        this.announce(this.dataset.cancelMessage);
        this.interestInputs[0]?.focus();
      }

      setBusy(busy) {
        this.busy = busy;
        this.submitButton.disabled = busy || !this.acknowledgement?.checked;
        if (this.acknowledgement) this.acknowledgement.disabled = busy || Boolean(this.added);
        this.continueButton.disabled = busy;
        if (this.fieldset) this.fieldset.disabled = busy || !this.added;
        this.submitButton.setAttribute('aria-busy', String(busy));
        this.continueButton.setAttribute('aria-busy', String(busy));
        this.submitLabel.textContent = busy ? this.submitButton.dataset.loadingLabel : this.submitButton.dataset.defaultLabel;
        this.continueButton.textContent = busy ? this.dataset.savingInterest : this.dataset.continueBasket;
      }

      announce(message, tone = 'neutral') {
        this.status.textContent = message;
        this.status.dataset.tone = tone;
      }

      showEvidence(line) {
        if (!this.evidence) return;
        this.evidence.querySelector('pre').textContent = JSON.stringify({
          synthetic: true, shopifyOrder: false, payment: false, notification: false, line
        }, null, 2);
        this.evidence.hidden = false;
      }

      quantityConfirmation(line, existing) {
        if (Number(this.dataset.maxQuantity) !== 2) {
          return existing ? this.dataset.existingHeading : this.dataset.addedHeading;
        }
        if (Number(line.quantity) === 2) {
          return existing ? this.dataset.additionalTwoExisting : this.dataset.additionalTwoAdded;
        }
        return existing ? this.dataset.additionalOneExisting : this.dataset.additionalOneAdded;
      }

      async handleSubmit(event, continueToBasket = false) {
        event.preventDefault();
        if (!this.added && !this.acknowledgement?.checked) {
          this.announce(this.dataset.advancePurchaseRequired, 'error');
          this.acknowledgement?.focus();
          this.acknowledgement?.reportValidity();
          return;
        }
        if (!this.gate.start()) return;
        continueToBasket = continueToBasket || this.added;
        const formData = new FormData(this.form);
        const valid = buildLine({
          variantId: formData.get('id'), quantity: formData.get('quantity'),
          interest: '', state: this.dataset.state, maxQuantity: Number(this.dataset.maxQuantity) || 1
        });
        if (!valid.ok) {
          this.announce(this.dataset.invalidMessage, 'error');
          this.gate.finish();
          return;
        }
        this.setBusy(true);
        this.recovery.hidden = true;
        this.announce(continueToBasket ? this.dataset.savingInterest : this.submitButton.dataset.loadingLabel);
        try {
          if (!continueToBasket) {
            const { line, existing } = await this.journey.add(valid.line.quantity);
            this.added = true;
            this.nextStep.hidden = false;
            this.submitButton.hidden = true;
            this.confirmation.textContent = this.quantityConfirmation(line, existing);
            this.interestInputs.forEach((input) => {
              input.checked = false;
            });
            this.currentInterest = '';
            if (this.cancelInterestButton) this.cancelInterestButton.hidden = false;
            this.announce('');
            this.showEvidence(line);
            this.confirmation.focus();
          } else {
            const interest = this.currentInterest;
            if (interest === null || interest === undefined) {
              this.announce(this.dataset.invalidMessage, 'error');
              this.setBusy(false);
              this.interestInputs[0]?.focus();
              return;
            }
            const result = await this.journey.save(interest);
            if (this.dataset.synthetic === 'true') {
              this.showEvidence(result);
              this.announce(this.dataset.previewComplete);
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
          }
        } catch (error) {
          this.announce(continueToBasket ? this.dataset.interestError : this.dataset.addError, 'error');
          this.recovery.hidden = this.dataset.synthetic === 'true';
        } finally {
          this.setBusy(false);
          this.gate.finish();
        }
      }
    }
    globalThis.SCDadsHatPreview = Object.freeze({
      ATTRIBUTE_NAME,
      readInterest,
      normalizeInterest,
      buildLine,
      createSubmissionGate,
      findBottle,
      createCartJourney,
      createAjaxTransport,
      createSyntheticTransport
    });

    if (!customElements.get('sc-dads-hat-offer')) {
      customElements.define('sc-dads-hat-offer', SCDadsHatOffer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-gift-message-editor"] && !Shopify.designMode) return;
  try {
    
  class ScGiftMessageEditor extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.designs = Array.from(this.querySelectorAll('[data-sc-gift-design]'));
      this.designValue = this.querySelector('[data-sc-gift-design-value]');
      this.variantValue = this.querySelector('[data-sc-gift-variant-value]');
      this.styleValue = this.querySelector('[data-sc-gift-style-value]');
      this.previewMedia = this.querySelector('[data-sc-gift-preview-media]');
      this.previewImage = this.querySelector('[data-sc-gift-preview-image]');
      this.previewPlaceholder = this.querySelector('[data-sc-gift-placeholder]');
      this.artwork = this.querySelector('[data-sc-gift-artwork]');
      this.artworkImage = this.querySelector('[data-sc-gift-artwork-image]');
      this.recipient = this.querySelector('[data-sc-gift-recipient]');
      this.occasion = this.querySelector('[data-sc-gift-occasion]');
      this.message = this.querySelector('[data-sc-gift-message]');
      this.previewCopy = this.querySelector('[data-sc-gift-preview-copy]');
      this.count = this.querySelector('[data-sc-gift-count]');
      this.clearButton = this.querySelector('[data-sc-gift-clear]');
      this.saveButton = this.querySelector('[data-sc-gift-save]');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-sc-gift-status]');

      this.designHandlers = this.designs.map((design) => {
        const handler = () => this.selectDesign(design);
        design.addEventListener('change', handler);
        return { design, handler };
      });
      this.messageHandler = () => this.updateMessage();
      this.message?.addEventListener('input', this.messageHandler);
      this.clearHandler = () => this.clear();
      this.clearButton?.addEventListener('click', this.clearHandler);
      this.saveHandler = () => this.saveProductLine();
      this.saveButton?.addEventListener('click', this.saveHandler);
      this.formHandler = (event) => {
        if (!this.validateMessage()) event.preventDefault();
      };
      this.form?.addEventListener('submit', this.formHandler);
      this.updateMessage();
      this.updatePreviewStyle(this.styleValue?.value || '');
    }

    disconnectedCallback() {
      this.designHandlers?.forEach(({ design, handler }) => design.removeEventListener('change', handler));
      this.message?.removeEventListener('input', this.messageHandler);
      this.clearButton?.removeEventListener('click', this.clearHandler);
      this.saveButton?.removeEventListener('click', this.saveHandler);
      this.form?.removeEventListener('submit', this.formHandler);
    }

    selectDesign(design) {
      if (this.designValue) this.designValue.value = design.dataset.designValue || design.value;
      if (this.variantValue && design.dataset.variantId) this.variantValue.value = design.dataset.variantId;
      if (this.styleValue) this.styleValue.value = design.dataset.style || '';
      if (this.previewImage && design.dataset.image) {
        this.previewImage.src = design.dataset.image;
        this.previewImage.alt = design.dataset.imageAlt || '';
        this.previewImage.hidden = false;
        if (this.previewPlaceholder) this.previewPlaceholder.hidden = true;
      }
      if (this.dataset.previewNatural === 'true' && this.previewMedia && design.dataset.imageAspect) {
        this.previewMedia.style.aspectRatio = design.dataset.imageAspect;
      }
      if (this.artwork && this.artworkImage) {
        const showArtwork = this.dataset.showArtworkPreview === 'true' && design.dataset.hasReverse === 'true';
        this.artwork.hidden = !showArtwork;
        if (showArtwork && design.dataset.artworkImage) {
          this.artworkImage.src = design.dataset.artworkImage;
          this.artworkImage.alt = design.dataset.imageAlt || '';
          this.artworkImage.hidden = false;
        }
        if (this.dataset.previewNatural === 'true' && showArtwork && design.dataset.artworkAspect) {
          this.artwork.style.aspectRatio = design.dataset.artworkAspect;
        }
      }
      this.updatePreviewStyle(design.dataset.style || '');
      if (this.status) this.status.textContent = `${design.dataset.designValue || design.value} ${this.dataset.selectedLabel || 'selected'}`;
    }

    updatePreviewStyle(style) {
      const isHandwritten = String(style).toLowerCase().includes('handwritten');
      this.previewCopy?.classList.toggle('is-handwritten', isHandwritten);
      this.message?.classList.toggle('is-handwritten', isHandwritten);
    }

    updateMessage() {
      const value = this.message?.value || '';
      if (this.previewCopy) this.previewCopy.textContent = value;
      if (this.count) this.count.textContent = String(value.length);
    }

    containsBlockedWords(value) {
      const blockedWords = [
        'fuck', 'fucking', 'fucker', 'motherfucker', 'shit', 'bullshit', 'cunt',
        'bitch', 'bastard', 'wanker', 'prick', 'twat', 'arsehole', 'asshole', 'dickhead',
      ];
      const normalised = String(value || '')
        .toLowerCase()
        .replace(/[@]/g, 'a')
        .replace(/[!1|]/g, 'i')
        .replace(/[$5]/g, 's')
        .replace(/[0]/g, 'o')
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      return blockedWords.some((word) => new RegExp(`\\b${word}\\b`, 'i').test(normalised));
    }

    validateMessage() {
      const message = this.message?.value.trim() || '';
      if (this.dataset.messageRequired === 'true' && !message) {
        if (this.status) this.status.textContent = this.dataset.messageRequiredLabel || 'Add a message.';
        this.message?.focus();
        return false;
      }
      if (this.dataset.blockOffensiveLanguage === 'true' && this.containsBlockedWords(message)) {
        if (this.status) {
          this.status.textContent = this.dataset.blockedMessageLabel
            || 'Please amend your message before saving. We are unable to include offensive language.';
        }
        this.message?.focus();
        return false;
      }
      return true;
    }

    route(path) {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}${path}`;
    }

    async request(path, options = {}) {
      const response = await fetch(this.route(path), {
        ...options,
        headers: {
          Accept: 'application/json',
          ...(options.body ? { 'Content-Type': 'application/json' } : {}),
          ...(options.headers || {}),
        },
      });
      if (!response.ok) throw new Error(this.dataset.errorLabel || 'The gift message could not be saved.');
      return response.json();
    }

    managedProperties() {
      const properties = {};
      if (this.dataset.markerKey) properties[this.dataset.markerKey] = this.dataset.markerValue || 'true';
      if (this.dataset.designKey) properties[this.dataset.designKey] = this.designValue?.value || '';
      if (this.dataset.recipientKey) properties[this.dataset.recipientKey] = this.recipient?.value.trim() || '';
      if (this.dataset.occasionKey) properties[this.dataset.occasionKey] = this.occasion?.value || '';
      if (this.dataset.messageKey) properties[this.dataset.messageKey] = this.message?.value.trim() || '';
      if (this.dataset.styleKey && this.styleValue?.value) properties[this.dataset.styleKey] = this.styleValue.value;
      return properties;
    }

    managedLines(cart) {
      const productId = Number(this.dataset.productId || 0);
      const markerKey = this.dataset.markerKey;
      const markerValue = this.dataset.markerValue || 'true';
      return (cart.items || []).filter((item) => (
        item.product_id === productId
        && item.properties
        && item.properties[markerKey] === markerValue
      ));
    }

    changeLine(id, quantity, properties) {
      const body = { id, quantity };
      if (properties) body.properties = properties;
      return this.request('cart/change.js', { method: 'POST', body: JSON.stringify(body) });
    }

    addLine(variantId, properties) {
      return this.request('cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ id: Number(variantId), quantity: 1, properties }),
      });
    }

    setBusy(busy) {
      if (this.saveButton) this.saveButton.disabled = busy;
      if (this.clearButton) this.clearButton.disabled = busy;
    }

    async saveProductLine() {
      const variantId = this.variantValue?.value;
      if (!variantId) {
        if (this.status) this.status.textContent = this.dataset.designRequiredLabel || 'Choose a design.';
        return;
      }
      if (!this.validateMessage()) return;

      this.setBusy(true);
      if (this.status) this.status.textContent = this.dataset.savingLabel || 'Saving gift message...';
      try {
        const cart = await this.request('cart.js');
        const lines = this.managedLines(cart);
        const properties = this.managedProperties();
        if (lines.length === 1 && String(lines[0].variant_id) === String(variantId)) {
          await this.changeLine(lines[0].key, 1, properties);
        } else {
          for (const line of lines) await this.changeLine(line.key, 0);
          await this.addLine(variantId, properties);
        }
        window.location.assign(this.dataset.returnUrl || this.route('cart'));
      } catch (error) {
        if (this.status) this.status.textContent = error.message || this.dataset.errorLabel;
        this.setBusy(false);
      }
    }

    async clear() {
      if (this.dataset.saveMethod === 'product_line') {
        this.setBusy(true);
        try {
          const cart = await this.request('cart.js');
          for (const line of this.managedLines(cart)) await this.changeLine(line.key, 0);
          window.location.assign(this.dataset.returnUrl || this.route('cart'));
        } catch (error) {
          if (this.status) this.status.textContent = error.message || this.dataset.errorLabel;
          this.setBusy(false);
        }
        return;
      }

      this.form?.querySelectorAll('input[type="text"], textarea, select').forEach((field) => {
        field.value = '';
      });
      if (this.message && !this.form?.contains(this.message)) this.message.value = '';
      if (this.designValue) this.designValue.value = '';
      this.designs.forEach((design) => { design.checked = false; });
      this.updateMessage();
      this.form?.requestSubmit();
    }
  }

  if (!customElements.get('sc-gift-message-editor')) {
    customElements.define('sc-gift-message-editor', ScGiftMessageEditor);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-personalisation-preview"] && !Shopify.designMode) return;
  try {
    
  class ScPersonalisationPreview extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.inputs = Array.from(this.querySelectorAll('[data-sc-personalisation-input]'));
      this.resetButton = this.querySelector('[data-sc-personalisation-reset]');
      this.status = this.querySelector('[data-sc-personalisation-status]');
      this.inputHandlers = this.inputs.map((input) => {
        const handler = () => this.update(input);
        input.addEventListener('input', handler);
        this.update(input);
        return { input, handler };
      });
      this.resetHandler = () => this.reset();
      this.resetButton?.addEventListener('click', this.resetHandler);
      this.submitHandler = (event) => {
        if (event.target.matches('form[action*="/cart/add"]')) this.syncToForm(event.target);
      };
      document.addEventListener('submit', this.submitHandler, true);
      this.syncToForm();
    }

    disconnectedCallback() {
      this.inputHandlers?.forEach(({ input, handler }) => input.removeEventListener('input', handler));
      this.resetButton?.removeEventListener('click', this.resetHandler);
      document.removeEventListener('submit', this.submitHandler, true);
    }

    update(input) {
      const id = input.dataset.scPersonalisationInput;
      const output = this.querySelector(`[data-sc-personalisation-output="${CSS.escape(id)}"]`);
      const count = this.querySelector(`[data-sc-personalisation-count="${CSS.escape(id)}"]`);
      if (output) output.textContent = input.value || input.placeholder || '';
      if (count) count.textContent = String(input.value.length);
      this.syncToForm();
      if (this.status) this.status.textContent = `${this.dataset.updatedLabel || 'Preview updated'}: ${input.previousElementSibling?.textContent || ''}`;
    }

    reset() {
      this.inputs.forEach((input) => {
        input.value = input.dataset.defaultValue || '';
        this.update(input);
      });
    }

    syncToForm(form) {
      if (this.dataset.syncProductForm !== 'true') return;
      const productForm = form || document.querySelector('form[action*="/cart/add"]');
      if (!productForm) return;
      this.inputs.forEach((input) => {
        const propertyName = input.dataset.propertyName;
        if (!propertyName) return;
        const fieldName = `properties[${propertyName}]`;
        let hidden = Array.from(productForm.elements).find((field) => field.name === fieldName);
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = fieldName;
          productForm.appendChild(hidden);
        }
        hidden.value = input.value;
      });
    }
  }

  if (!customElements.get('sc-personalisation-preview')) {
    customElements.define('sc-personalisation-preview', ScPersonalisationPreview);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-private-cask-enquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const publish = (eventName, detail) => {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, detail);
        return;
      }

      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    };

    const initialise = () => {
      const root = document.querySelector('[data-private-cask-enquiry]');
      if (!root) return;

      const source = root.dataset.privateCaskAnalyticsSource || 'private-cask-landing-page';
      const detail = { source, path: window.location.pathname };

      if (!window.__harrisPrivateCaskLandingViewTracked) {
        window.__harrisPrivateCaskLandingViewTracked = true;
        publish('private_cask_landing_view', detail);
      }

      if (!window.__harrisPrivateCaskInscriptionBound) {
        window.__harrisPrivateCaskInscriptionBound = true;
        const inputs = document.querySelectorAll('[data-sc-personalisation-input]');
        const trackInteraction = () => {
          if (window.__harrisPrivateCaskInscriptionTracked) return;
          window.__harrisPrivateCaskInscriptionTracked = true;
          publish('private_cask_inscription_interaction', detail);
        };
        inputs.forEach((input) => input.addEventListener('input', trackInteraction));
      }

      if (root.querySelector('[data-private-cask-enquiry-success]') && !window.__harrisPrivateCaskEnquiryTracked) {
        window.__harrisPrivateCaskEnquiryTracked = true;
        publish('private_cask_enquiry_submit', detail);
      }

      const form = root.querySelector('form');
      const requests = Array.from(root.querySelectorAll('[data-private-cask-request]'));
      const message = root.querySelector('[data-private-cask-message]');
      const requestError = root.querySelector('[data-private-cask-request-error]');

      if (form && requests.length && message && requestError && form.dataset.privateCaskValidationReady !== 'true') {
        form.dataset.privateCaskValidationReady = 'true';
        const clearError = () => {
          requestError.hidden = true;
          requests.forEach((request) => request.removeAttribute('aria-invalid'));
          message.removeAttribute('aria-invalid');
        };
        const hasRequest = () => requests.some((request) => request.checked) || message.value.trim().length > 0;

        form.addEventListener('submit', (event) => {
          if (hasRequest()) return;
          event.preventDefault();
          requestError.hidden = false;
          requests.forEach((request) => request.setAttribute('aria-invalid', 'true'));
          message.setAttribute('aria-invalid', 'true');
          requests[0].focus();
        });
        requests.forEach((request) => request.addEventListener('change', clearError));
        message.addEventListener('input', clearError);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }

    document.addEventListener('shopify:section:load', initialise);
  })();

  } catch(e) { console.error(e); }
})();
})();
